export default {
  ON_AFTER_ADD_NEW_PAGE: 'afterAddNewPage',
  ON_AFTER_DELETE_PAGE: 'afterDeletePage',
  ON_AFTER_CHANGE_HOME_PAGE: 'afterChangeHomePage',
  ON_AFTER_UPDATE_PAGE_SETTINGS: 'afterUpdatePageSettings',
  ON_BEFORE_BLUR_FOCUSED_ELEMENT: 'beforeBlurFocusedElement',
  ON_AFTER_BLUR_FOCUSED_ELEMENT: 'afterBlurFocusedElement',
  ON_AFTER_VIEW_SCROLLER_INITIALIZED: 'onAfterViewScrollerInitialized',
  ON_BEFORE_SYNCHRONIZE_STATIC_ELEMENT: 'beforeSynchronizeStaticElement',
};
